import { createFeature, createReducer, on } from '@ngrx/store';
import { ExcludeDate } from '../../general/shared/interfaces/exclude-date.interface';
import { Granularity } from '../../general/shared/services/appsettings/granularity.enum';
import { setDateFilter } from './date-filter.actions';
import { TimeframePresets } from '../../general/enums/timeframe.presets';
import { calculateDatesFromTimeframe } from '../../general/utils/timeframe.utils';

export interface DateFilter {
	startDate: number;
	endDate: number;
	granularity: Granularity;
	shiftOn: boolean;
	shiftStart: number;
	shiftEnd: number;
	shiftDays: string[];
	excludeDates: ExcludeDate[];
	selectedDays: number;
	timeframe: TimeframePresets;
}

const initialState: DateFilter = {
	startDate: 0,
	endDate: 0,
	granularity: Granularity.hh,
	shiftOn: false,
	shiftStart: 0,
	shiftEnd: 0,
	shiftDays: [],
	excludeDates: [],
	selectedDays: 0,
	timeframe: TimeframePresets.Last7Days,
};

export const calculateSelectedDays = (startDate: number, endDate: number): number => {
	if (!startDate || !endDate) return 0;
	const diffInMs = endDate - startDate;
	const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
	return Math.max(0, diffInDays);
};

const reducer = createReducer(
	initialState,
	on(setDateFilter, (state, action) => {
		let newState = { ...state, ...action.value };

		if (
			newState.timeframe &&
			newState.timeframe !== TimeframePresets.CustomTimeFrame &&
			newState.timeframe !== state.timeframe
		) {
			const { startDate, endDate } = calculateDatesFromTimeframe(newState.timeframe);
			newState = { ...newState, startDate, endDate };
		}

		return {
			...newState,
			selectedDays: calculateSelectedDays(newState.startDate, newState.endDate),
		};
	})
);

export const dateFilterFeature = createFeature({ name: 'globalDateFilter', reducer });
